let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("38IH5")).then(() => parcelRequire('21yAX'));